import { Component, OnInit } from '@angular/core';
import { ColoracaoService } from "./coloracao.service";
import { ColoracaoModel } from "./coloracao.model";
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "../login/login.service";

declare var swal: any;

@Component({
  selector: 'app-coloracao',
  templateUrl: './coloracao.component.html'
})
export class ColoracaoComponent extends Components implements OnInit {

  coloracoes: ColoracaoModel[] = [];
  privilegioUsuario = { "editar": false, "consultar": false };

  constructor(
    private coloracaoService: ColoracaoService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for (let i in data.privilegios) {
        if (data.privilegios[i].id_acao == '24') {
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.coloracaoService.getPaginacao(1, this.itensPorPagina)
      .subscribe(data => {
        this.coloracoes = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.coloracoes);
        }
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  delete(coloracao) {
    let coloracoes = this.coloracoes;
    let coloracaoService = this.coloracaoService;
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarColoracao') || 'Deseja deletar a coloração: ' + coloracao.nome_pt,
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        if (self.global.debug == true) {
          console.log(coloracoes);
        }

        let index = coloracoes.indexOf(coloracao);
        coloracoes.splice(index, 1);

        coloracaoService.apagar(coloracao.id)
          .subscribe(res => {
            self.coloracoes = coloracoes;
          },
            err => {
              coloracoes.splice(index, 0, coloracao);
              self.coloracoes = coloracoes;
              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina) {
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.coloracaoService.getPaginacao(pagina, this.itensPorPagina)
      .subscribe(data => {
        this.coloracoes = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/laudos-cd-coloracao/coloracao.component.ts